export const mixerStreamId = {
  type: "string",
  minLength: 1,
  maxLength: 1_000
};
